export default __webpack_public_path__ + "static/media/Social Links.ee153e9e.svg";